// extracted by mini-css-extract-plugin
export default {"card":"D5-z"};